import { utilsModule } from "../utils-module";

utilsModule.factory('blockService', ['$q', '$http', 'serverAddress', 'LoggedUserService',function ($q, $http, serverAddress, LoggedUserService) {    

    var cachedList = undefined;

    return {
        get: function (blockId) {
            var d = $q.defer();
            var blockServerAddress = serverAddress.javaURL + '/bloco';
            $http({
                method: "GET",
                url: blockServerAddress + '/get/' + blockId + '/' + LoggedUserService.loggedUser.id + '/' + LoggedUserService.loggedUser.senha,
                params: {login_type: LoggedUserService.type}
            }).then(function (response) {
                d.resolve(response.data);
            }, function () {
                d.reject();
            });

            return d.promise;
        },

        list : function(){
            var d = $q.defer();
            $http.get(serverAddress.nodeURL + '/Blocos/')
            .then(function(result){
                d.resolve(result.data);
            })
            .catch(function(err){
                d.reject(err);
            });
            return d.promise;
        },

        listCached : function(){
            var deferred = $q.defer();

            if (!cachedList) {
                this.list().then(function(listed){
                    cachedList = listed;
                    deferred.resolve(listed);
                },function(){
                    deferred.reject();
                });
            }else{
                deferred.resolve(cachedList);
            }

            return deferred.promise;
        },

        getProductsForBlock: function(blockId) {
            var d = $q.defer();
            var filter = {
              fields: [
                'idProduto','exibirItemBloco'
              ]
            }
            $http.get(serverAddress.nodeURL + '/Blocos/' + blockId + '/blocoProduto?filter=' + JSON.stringify(filter)).then(function(response){
              d.resolve(response.data);
            }).catch(function(){
              d.reject();
            });
            return d.promise;
        }
    };
}]);
